export const ProjectsData = [
  {
    title: "Odigodi",
    description: "A web service that provides information on actual transaction prices for rent and sales.",
    image: "/static/odigodi.png",
    GitHub: 'https://github.com/ampersandor/odigodi',
    hosted: 'https://odigodi.com/',
  },
  {
    title: "Excel Writer",
    description: "A python project that provides a custom framework built on the xlsxwriter library",
    image: "/static/excel-writer.png",
    GitHub: 'https://github.com/ampersandor/excel-writer',
    hosted: '',
  },
  {
    title: "Leettrack",
    description: "A web service that you can track your team's progress on Leetcode",
    image: "/static/leettrack.png",
    GitHub: 'https://github.com/ampersandor/leettrack',
    hosted: '',
  },
  {
    title: "[Seegene] BlastAPI",
    description: "Parallelized blastn service using Azure Batch",
    image: "/static/seegene.png",
    GitHub: '',
    hosted: '',
  },
  {
    title: "[Seegene] AutoMSA",
    description: "Automatically collect sequences and align them using mafft",
    image: "/static/seegene.png",
    GitHub: '',
    hosted: '',
  },
  {
    title: "[Seegene] OligoMap",
    description: "A web service that generates a map image of the oligo sequence",
    image: "/static/seegene.png",
    GitHub: '',
    hosted: '',
  },
  {
    title: "[Seegene] MultiTOM",
    description: "Python software for designing Multiple TOCE Oligo Mixture for PCR production",
    image: "/static/seegene.png",
    GitHub: '',
    hosted: '',
  },
];
